<template>
    <div class="font-md rel r:8 h:48 lh:48px b:1|solid|gray300 flex-grow:1 {b:1|solid|y200;bg:y200}:has(input:checked)">
        <label class="cursor:pointer w:100% h:100% flex jc:center ai:center" :for="id">
            <slot></slot>
        </label>
        <input @change="$emit('update:modelValue', value)" :checked="checked" class="d:none" :id="id" type="radio" :value="value" v-bind="$attrs" />
    </div>
</template>

<script setup>
    const props = defineProps({
        id: { default: () => nextId(), type: String },
        modelValue: { type: [Number, String] },
        value: { required: true, type: [Number, String] }
    });

    const checked = computed(() => props.modelValue === props.value);

    defineOptions({ inheritAttrs: false });
</script>
